import { StyledSVG } from '../../Atoms/SVG/styles'
import { styled } from '../../Styles/stitches.config'

export const NextPrevLabel = styled('div', {
    color: '$primary600',
    cursor: 'pointer',
    display: 'flex',
    placeItems: 'center',
    placeContent: 'center',
    transition: '$fast',

    [`& ${StyledSVG}`]: {
        height: 20,
    },

    variants: {
        disabled: {
            true: {
                color: '$neutral200',
                cursor: 'default',
                pointerEvents: 'none',
            },
        },
    },
})

export const PageNumber = styled('div', {
    color: '$primary600',
    cursor: 'pointer',
    display: 'inline-flex',
    placeContent: 'center',
    placeItems: 'center',
    userSelect: 'none',

    variants: {
        active: {
            true: {
                textDecoration: 'underline',
                fontWeight: 600,
            },
        },
        ellipsis: {
            true: {
                cursor: 'default',
            },
        },
    },
})

export const StyledPagination = styled('div', {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '$2',
})
